import type {DirectMessageThread} from "../types";

function getThreadSortTime(thread: DirectMessageThread): number {
  const raw = thread.last_post_at ?? thread.updated_at;
  if (!raw) {
    return 0;
  }
  const time = Date.parse(raw);
  return Number.isNaN(time) ? 0 : time;
}

function mergeThreadRows(
  existing: DirectMessageThread,
  incoming: DirectMessageThread,
): DirectMessageThread {
  return {
    ...existing,
    ...incoming,
    has_unread_manager_posts:
      Boolean(existing.has_unread_manager_posts) || Boolean(incoming.has_unread_manager_posts),
    has_unread_posts: Boolean(existing.has_unread_posts) || Boolean(incoming.has_unread_posts),
  };
}

export function mergeAndSortThreads(threads: DirectMessageThread[]): DirectMessageThread[] {
  const byId = new Map<number, DirectMessageThread>();
  for (const thread of threads) {
    const existing = byId.get(thread.direct_message_thread_id);
    byId.set(
      thread.direct_message_thread_id,
      existing ? mergeThreadRows(existing, thread) : thread,
    );
  }
  return [...byId.values()].toSorted((a, b) => getThreadSortTime(b) - getThreadSortTime(a));
}

export function sliceConversationPage(
  threads: DirectMessageThread[],
  page: number,
  limit: number,
): DirectMessageThread[] {
  const start = (page - 1) * limit;
  return threads.slice(start, start + limit);
}
